import { WarningIcon } from "@/components/Icons";
import { t } from "@/i18n";
import { formatRelative } from "@/lib/format";

export function Staleness({
  lastFetched,
  loading,
  error,
  onRefresh,
}: {
  lastFetched?: Date;
  loading?: boolean;
  error?: Error;
  onRefresh: () => void;
}) {
  const stamp = lastFetched ? formatRelative(lastFetched.toISOString()) : t("staleness.never");
  return (
    <div class="staleness">
      {error && (
        <span class="hl-orange">
          <WarningIcon />
          {error.message}
        </span>
      )}
      {!error && <span>{t("staleness.lastRefresh", { when: stamp })}</span>}
      <button
        class="window-pill"
        style="margin-left: 8px; cursor: pointer;"
        onClick={onRefresh}
        disabled={loading}
      >
        {loading ? "…" : t("staleness.refresh")}
      </button>
    </div>
  );
}
